export default {
  computed: {
    datePickerLocale () {
      return this.$vuetify.lang.current === 'ua' ? 'uk' : undefined
    }
  }
}
